export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e504afe50cc35e0f133330284174899d8ccf0368&name=revalidateCommunity!'